/* ============================================
   ET - Reveal — shared staggered entrance animation.
   - Adds .et-reveal-scope to every [data-et-reveal] container (so if JS never
     runs, items stay visible — no hidden FOUC).
   - Observes the CONTAINER (not each item): when it scrolls into view, every
     .et-reveal inside reveals, staggered by --et-reveal-i. Container-based so
     off-screen slider cards (horizontal peek) reveal correctly too.
   - window.EtReveal.replay(container) re-runs the animation for a container's
     items (used by tab switches so it plays every time, first or not).
   ============================================ */
(function () {
  'use strict';

  var io = null;

  function revealAll(scope) {
    scope.querySelectorAll('.et-reveal').forEach(function (item) {
      item.classList.add('is-visible');
    });
  }

  function getIO() {
    if (io) return io;
    if (!('IntersectionObserver' in window)) return null;
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          revealAll(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -8% 0px' });
    return io;
  }

  function initScope(root) {
    if (!root || !root.querySelectorAll) return;

    var scopes = Array.prototype.slice.call(root.querySelectorAll('[data-et-reveal]'));
    if (root.matches && root.matches('[data-et-reveal]')) scopes.push(root);

    scopes.forEach(function (scope) {
      scope.classList.add('et-reveal-scope');
      if (scope.__etRevealDone) return;
      scope.__etRevealDone = true;

      var obs = getIO();
      if (!obs) { revealAll(scope); return; }
      obs.observe(scope);
    });
  }

  function replay(container) {
    if (!container) return;
    var items = container.querySelectorAll('.et-reveal');
    // Reset to the hidden state INSTANTLY (no transition), so we don't see a
    // half-played "exit" before the re-entrance.
    items.forEach(function (i) {
      i.style.transition = 'none';
      i.classList.remove('is-visible');
    });
    // Force reflow so the instant reset is committed.
    void container.offsetWidth;
    requestAnimationFrame(function () {
      items.forEach(function (i) {
        i.style.transition = '';
        i.classList.add('is-visible');
      });
    });
  }

  window.EtReveal = { init: initScope, replay: replay };

  function boot() { initScope(document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) initScope(e.target);
  });
})();
